export default __webpack_public_path__ + "static/media/genshin_star.21334c81.svg";